export const wxMethods: WX['miniProgram'] = {
  navigateTo: (opt) =>
    wx && wx.miniProgram && wx.miniProgram.navigateTo && wx.miniProgram.navigateTo(opt),
};
